import script from "./loadingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./loadingPage.vue?vue&type=script&setup=true&lang=js"

import "./loadingPage.vue?vue&type=style&index=0&id=9fed9668&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fed9668"]])

export default __exports__